import { showError } from "./trend-actions";

let embedScriptPromise;

export function initialiseClipboard() {
    document.querySelectorAll(".clipboard-copier").forEach((button) => {
        button.addEventListener("click", async () => {
            const textarea = document.querySelector(button.dataset.clipboardTarget);
            if (!textarea) return;
            try {
                if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText(textarea.value);
                } else {
                    textarea.focus();
                    textarea.select();
                    if (!document.execCommand("copy")) throw new Error("Copy unavailable");
                }
                button.textContent = "Copied!";
            } catch (error) {
                textarea.focus();
                textarea.select();
                showError(button, "Select and copy the code above.");
            }
        });
    });
}

export function initialiseEmbedPreview() {
    const embedModal = document.getElementById("embed");
    if (!embedModal) {
        return;
    }

    let desktopInitialised = false;
    let mobileInitialised = false;

    const ensureEmbedScriptLoaded = async () => {
        if (typeof window.initInsightsEmbeds === "function") {
            return true;
        }

        if (!embedScriptPromise) {
            const scriptUrl = embedModal.dataset.embedScriptUrl;
            if (!scriptUrl) {
                return false;
            }

            embedScriptPromise = new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = scriptUrl;
                script.async = true;
                script.onload = () => resolve(true);
                script.onerror = () => reject(new Error("Unable to load embed.js"));
                document.body.appendChild(script);
            }).catch((error) => {
                console.error(error);
                embedScriptPromise = undefined;
                return false;
            });
        }

        return embedScriptPromise;
    };

    const initialiseEmbed = async (embedId) => {
        const loaded = await ensureEmbedScriptLoaded();
        if (!loaded) {
            return false;
        }

        if (typeof window.initInsightsEmbeds !== "function") {
            return false;
        }

        window.initInsightsEmbeds(`#${embedId}`);
        return true;
    };

    const preloadEmbedScript = () => {
        void ensureEmbedScriptLoaded();
    };

    document
        .querySelectorAll('[data-bs-target="#embed"]')
        .forEach((trigger) => {
            trigger.addEventListener("pointerenter", preloadEmbedScript, {
                once: true,
            });
            trigger.addEventListener("focus", preloadEmbedScript, {
                once: true,
            });
        });

    embedModal.addEventListener("show.bs.modal", preloadEmbedScript);

    embedModal.addEventListener("shown.bs.modal", () => {
        window.setTimeout(async () => {
            if (!desktopInitialised) {
                desktopInitialised = await initialiseEmbed("embed-desktop-preview");
            }
        }, 100);
    });

    const mobileTab = document.getElementById("mobile-tab");
    mobileTab?.addEventListener("shown.bs.tab", () => {
        window.setTimeout(async () => {
            if (!mobileInitialised) {
                mobileInitialised = await initialiseEmbed("embed-mobile-preview");
            }
        }, 50);
    });
}
